module.exports = __webpack_public_path__ + "img/cirno_sc1.26ecd636.png";